module.exports = __webpack_public_path__ + "img/memory_pc_hover.390401de.svg";